import { getKnownTracker } from "../../lib/getKnownTracker";
import type { KnownTracker } from "../../lib/KnownTrackers";
import { DbRecordedEvent } from "../../State/EvidenceDB/DatabaseTypes";
import { NetworkTrafficRecordingState } from "../../State/NetworkTrafficRecordingState";
import { InstrumentationReportingState } from "./InstrumentationReportingState";
import { RecordingCookiesSent } from "./RecordingCookiesSent";
import { RecordingSearchState } from "./RecordingSearchState";


export const getTrackingSummaryReportState = ({ networkTrafficRecordingState, cookiesSent, instrumentationReportingState, searchState }: {
	networkTrafficRecordingState: NetworkTrafficRecordingState;
	instrumentationReportingState: InstrumentationReportingState;
	cookiesSent: RecordingCookiesSent;
	searchState?: RecordingSearchState;
}) => {
	const { sourceRegisteredDomainToThirdPartyDestinations } = networkTrafficRecordingState;
	const searchResultsBySourceRegisteredDomain = searchState?.searchResultsBySourceRegisteredDomain;
	const searchResultsBySourceRegisteredDomainMap = new Map(searchResultsBySourceRegisteredDomain?.map(s => [s.sourceRegisteredDomain, s.destinations]));
	const resultsBySourceRegisteredDomain = sourceRegisteredDomainToThirdPartyDestinations.map(([sourceRegisteredDomain, destinations]) => {
		const searchResultsByDestination = new Map(
			(searchResultsBySourceRegisteredDomainMap.get(sourceRegisteredDomain) ?? []).map(d => ([d.destinationRegisteredDomain, d])));
		const resultsByDestinationRegisteredDomain = [...destinations.values()].map((destination) => {
			const { registeredDomain: destinationRegisteredDomain, domains } = destination;
			const cookiesByName = cookiesSent.cookiesByRegisteredDomain.get(sourceRegisteredDomain)?.get(destinationRegisteredDomain);
			const cookies = [...(cookiesByName?.values() ?? [])];
			const searchResults = searchResultsByDestination.get(destinationRegisteredDomain);
			const { sourceRegDomainToCodeDomainToInstrumentationData: sourceRegDomainToCodeRegDomainToInstrumentationData } = instrumentationReportingState;
			const behaviorsObservedAtCodeLocation = sourceRegDomainToCodeRegDomainToInstrumentationData.get(sourceRegisteredDomain)?.codeRegisteredDomainToInstrumentationData.get(destinationRegisteredDomain)?.behaviorsObserved;
			const destinationDomains = [...domains.values()];
			let knownTracker: KnownTracker | undefined = getKnownTracker(destinationRegisteredDomain);
			if (knownTracker == null) {
				destinationDomains.find(d => (knownTracker = getKnownTracker(d.domain)) != null);
			}

			return {
				destinationRegisteredDomain, cookies, searchResults,
				behaviorsObservedAtCodeLocation, destinationDomains, knownTracker
			};
		}).sort((a, b) => (a.knownTracker?.organizationKnownAs ?? a.destinationRegisteredDomain).localeCompare(
			b.knownTracker?.organizationKnownAs ?? b.destinationRegisteredDomain));
		return { sourceRegisteredDomain, resultsByDestinationRegisteredDomain };
	}).sort((a, b) => b.resultsByDestinationRegisteredDomain.length - a.resultsByDestinationRegisteredDomain.length);
	return resultsBySourceRegisteredDomain;
};
export type TrackingSummaryReportState = ReturnType<typeof getTrackingSummaryReportState>;